<mat-expansion-panel
  [formGroup]="form"
  class="width-100-percent color-background"
  [expanded]="isExpanded">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{config.deviceName}}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <div *ngIf="context === TYPE.TEST_CREATION" class="u-padding-16 u-border-radius color-background-box test-equipment__device-selection-box">
    <p class="u-font-size-14 u-font-weight-500">Device Selection</p>
    <mat-radio-group color="primary" formControlName="selected_device" (change)="selectDefaultDevices($event)">
      <mat-radio-button class="test-equipment__radio_button u-margin-top-10 u-margin-bottom-10" *ngFor="let item of deviceSelectionList" [value]="item.value" [disabled]="item.disabled">
        <div class="o-flex o-flex--column line-height-16">
          <span class="u-font-size-14 u-font-weight-400">{{item.name}}</span>
          <span class="feature-detail-second-color u-font-size-xsmall u-font-weight-400">{{item.subName}}</span>
        </div>
      </mat-radio-button>
    </mat-radio-group>
  </div>
  <mat-form-field appearance="outline" floatLabel="always" class="width-100-percent u-margin-top-20">
    <mat-label>Select device</mat-label>
    <mat-select formControlName="id" placeholder="Select" (selectionChange)="onComboBoxChanged($event)">
      <mat-option *ngFor="let item of optionList" [value]="item.id">{{item.name}}</mat-option>
    </mat-select>
  </mat-form-field>
  <ng-container *ngIf="isShowErrorFunction">
    <div class="u-margin-bottom-8" *ngIf="isShowErrorFunction2">VO2 Measurement</div>
    <div class="u-position-relative test-equipment o-flex o-flex--justify-space-between">
      <mat-form-field class="width-33-percent" appearance="outline" floatLabel="always">
        <mat-label>Error Function</mat-label>
        <mat-select formControlName="selected_error_function" (selectionChange)="onErrorFunctionChanged($event)">
          <mat-option *ngFor="let item of errorFunctionOptionList" [value]="item.value">{{item.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <ng-container *ngIf="errorFunctionType === ERROR_FUNCTION_ENUM.LINEAR">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>a (slope) {{config.created_at}}</mat-label>
          <input matInput type="number" formControlName="a_slope" (input)="onInputChanged()">
          <mat-error *ngIf="a_slope?.hasError('min')">Should be higher {{a_slope?.errors?.min?.min}}</mat-error>
          <mat-error *ngIf="a_slope?.hasError('max')">Should be maximum {{a_slope?.errors?.max?.max}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>b (offset)</mat-label>
          <input matInput type="number" formControlName="b_offset" (input)="onInputChanged()">
          <mat-error *ngIf="b_offset?.hasError('min')">Should be higher {{b_offset?.errors?.min?.min}}</mat-error>
          <mat-error *ngIf="b_offset?.hasError('max')">Should be maximum {{b_offset?.errors?.max?.max}}</mat-error>
        </mat-form-field>
      </ng-container>
      <ng-container *ngIf="errorFunctionType === ERROR_FUNCTION_ENUM.EXPONENTIAL">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>a</mat-label>
          <input matInput type="number" formControlName="a" (input)="onInputChanged()">
          <mat-error *ngIf="a?.hasError('min')">Should be higher {{a?.errors?.min?.min}}</mat-error>
          <mat-error *ngIf="a?.hasError('max')">Should be maximum {{a?.errors?.max?.max}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>b</mat-label>
          <input matInput type="number" formControlName="b" (input)="onInputChanged()">
          <mat-error *ngIf="b?.hasError('min')">Should be higher {{b?.errors?.min?.min}}</mat-error>
          <mat-error *ngIf="b?.hasError('max')">Should be maximum {{b?.errors?.max?.max}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>c</mat-label>
          <input matInput type="number" formControlName="c" (input)="onInputChanged()">
          <mat-error *ngIf="c?.hasError('min')">Should be higher {{c?.errors?.min?.min}}</mat-error>
          <mat-error *ngIf="c?.hasError('max')">Should be maximum {{c?.errors?.max?.max}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>d</mat-label>
          <input matInput type="number" formControlName="d" (input)="onInputChanged()">
          <mat-error *ngIf="d?.hasError('min')">Should be higher {{d?.errors?.min?.min}}</mat-error>
          <mat-error *ngIf="d?.hasError('max')">Should be maximum {{d?.errors?.max?.max}}</mat-error>
        </mat-form-field>
      </ng-container>
      <div class="test-equipment__equation position-absolute u-font-weight-400">
        <span *ngIf="errorFunctionType === ERROR_FUNCTION_ENUM.LINEAR">y(x)=a*x+b</span>
        <span *ngIf="errorFunctionType === ERROR_FUNCTION_ENUM.EXPONENTIAL">y(x)=a*[b-exp(-c*x)]+d</span>
      </div>
    </div>
    <app-lock (onLockChanged)="onLockChanged($event)" [isLock]=isLock></app-lock>
  </ng-container>
  <ng-container *ngIf="isShowErrorFunction2">
    <hr class="u-margin-top-30 u-margin-bottom-10">
    <div class="u-margin-bottom-8" *ngIf="isShowErrorFunction2">VCO2 Measurement</div>
    <div class="u-position-relative test-equipment o-flex o-flex--justify-space-between">
      <mat-form-field class="width-33-percent" appearance="outline" floatLabel="always">
        <mat-label>Error Function</mat-label>
        <mat-select formControlName="selected_error_function2" (selectionChange)="onErrorFunctionChanged2($event)">
          <mat-option *ngFor="let item of errorFunctionOptionList2" [value]="item.value">{{item.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <ng-container *ngIf="errorFunctionType2 === ERROR_FUNCTION_ENUM.LINEAR">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>a (slope)</mat-label>
          <input matInput type="number" formControlName="a_slope2" (input)="onInputChanged2()">
          <mat-error *ngIf="a_slope2?.hasError('min')">Should be higher {{a_slope2?.errors?.min?.min}}</mat-error>
          <mat-error *ngIf="a_slope2?.hasError('max')">Should be maximum {{a_slope2?.errors?.max?.max}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>b (offset)</mat-label>
          <input matInput type="number" formControlName="b_offset2" (input)="onInputChanged2()">
          <mat-error *ngIf="b_offset2?.hasError('min')">Should be higher {{b_offset2?.errors?.min?.min}}</mat-error>
          <mat-error *ngIf="b_offset2?.hasError('max')">Should be maximum {{b_offset2?.errors?.max?.max}}</mat-error>
        </mat-form-field>
      </ng-container>
      <ng-container *ngIf="errorFunctionType2 === ERROR_FUNCTION_ENUM.EXPONENTIAL">
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>a</mat-label>
          <input matInput type="number" formControlName="a2" (input)="onInputChanged2()">
          <mat-error *ngIf="a2?.hasError('min')">Should be higher {{a2?.errors?.min?.min}}</mat-error>
          <mat-error *ngIf="a2?.hasError('max')">Should be maximum {{a2?.errors?.max?.max}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>b</mat-label>
          <input matInput type="number" formControlName="b2" (input)="onInputChanged2()">
          <mat-error *ngIf="b2?.hasError('min')">Should be higher {{b2?.errors?.min?.min}}</mat-error>
          <mat-error *ngIf="b2?.hasError('max')">Should be maximum {{b2?.errors?.max?.max}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>c</mat-label>
          <input matInput type="number" formControlName="c2" (input)="onInputChanged2()">
          <mat-error *ngIf="c2?.hasError('min')">Should be higher {{c2?.errors?.min?.min}}</mat-error>
          <mat-error *ngIf="c2?.hasError('max')">Should be maximum {{c2?.errors?.max?.max}}</mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" floatLabel="always">
          <mat-label>d</mat-label>
          <input matInput type="number" formControlName="d2" (input)="onInputChanged2()">
          <mat-error *ngIf="d2?.hasError('min')">Should be higher {{d2?.errors?.min?.min}}</mat-error>
          <mat-error *ngIf="d2?.hasError('max')">Should be maximum {{d2?.errors?.max?.max}}</mat-error>
        </mat-form-field>
      </ng-container>
      <div class="test-equipment__equation position-absolute u-font-weight-400">
        <span *ngIf="errorFunctionType2 === ERROR_FUNCTION_ENUM.LINEAR">y(x)=a*x+b</span>
        <span *ngIf="errorFunctionType2 === ERROR_FUNCTION_ENUM.EXPONENTIAL">y(x)=a*[b-exp(-c*x)]+d</span>
      </div>
    </div>
    <app-lock (onLockChanged)="onLockChanged2($event)" [isLock]=isLock2></app-lock>
  </ng-container>
  <ng-container *ngIf="referenceArray?.length">
    <div class="u-margin-bottom-10">
      <app-test-equipment-references *ngIf="(context === TYPE.EQUIPMENT_PAGE || context === TYPE.ATHLETE_CREATION) && isShowErrorFunction || isShowErrorFunction2"  [referenceConfig]="referenceArray"></app-test-equipment-references>
    </div>
  </ng-container>

  <ng-container *ngIf="showRadioButtons()">
    <div class="u-padding-16 u-border-radius color-background-box">
      <p class="u-font-size-14 u-font-weight-500">Update defaults</p>
      <p *ngIf="showAthleteDefaultCheckbox()"><mat-checkbox (change)="toggleAthleteDefault($event)" color="primary" formControlName="athlete_default">Set as default for this athlete</mat-checkbox></p>
      <p *ngIf="showOrganizationDefaultCheckbox()"><mat-checkbox (change)="toggleorganizationDefault($event)" color="primary" formControlName="organization_default">Set as default for the organization</mat-checkbox></p>
    </div>
  </ng-container>
</mat-expansion-panel>
